import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import CarouselTiles from "../carouseltiles/carouseltiles.component";
import ModalCarousel from "../modalcarousel/modalcarousel.component";
import ModalVideoPlayer from "../modalvideoplayer/modalvideoplayer.component";
import CinemapRating from "../../../SHARED/components/cinemaprating/cinemaprating.component";
import LastNews from "../lastnews/lastnews.component";
import {API_URL} from "../../../SHARED/config/apiEndpoints";
import { requestLastNews } from '../../../SHARED/actions/news.actions';
import SearchByTag from "../../../SHARED/components/searchbytag/searchbytag.component";
import Comments from "../../../SHARED/components/comments/comments.component";
import RatingsComments from "../../../SHARED/components/ratingcomment/ratingcomment.component";
import SerialsRecommendedForYou from "../serialsrecommendedforyou/serialsrecommendedforyou.component";
import Ads from "../ads/ads.component";
import WeekDaysCards from "../../../SHARED/components/weekdayscards/weekdayscards.component";
import SelectHours from "../../../SHARED/components/selecthours/selecthours.component";
import Spinner from "../../../SHARED/components/spinner/spinner.component";
import { getMovieDetails, addMovieToFavorite, removeMovieFromFavorite } from '../../../SHARED/actions/movies.actions';
import Moment from 'react-moment';
import 'moment/locale/ro';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import ModalReservation from "../../../SHARED/components/modalreservation/modalreservation.component";
import ModalShare from "../../../SHARED/components/modalsharing/modalshare.component";
import {Helmet} from "react-helmet";
import {LOGIN_ROUTE} from "../../../SHARED/config/routes";
import Parser from 'html-react-parser';
import { sendMovieReview } from '../../../SHARED/actions/movies.actions';
import {withRouter} from 'react-router';
import { arrayClone, pageViewEvent } from '../../../SHARED/helpers/general.helper';
import ReactPlayer from 'react-player';
import { getFormattedTextForMeta } from '../../../SHARED/helpers/general.helper';
class MovieDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            openVideoPlayerModal: false,
            openShareModal: false,
            lastEventTitle: null,
        };

        this.openCarouselModal = this.openCarouselModal.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentWillMount(){
        const movieId = this.props.match.params.id;
        this.props.requestLastNews();
        this.props.getMovieDetails(movieId);
        window.prerenderReady = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            window.scrollTo(0, 0);
            this.props.getMovieDetails(nextProps.match.params.id);
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        window.addEventListener('load', this.handleLoad);
     }
    
     componentDidUpdate(){
        if(this.props.movie.film_translated_title && this.props.movie.film_translated_title !== this.state.lastEventTitle){
            pageViewEvent(this.props.movie.film_translated_title +' (' + this.props.movie.film_release_year+')', window.location.href)
            this.setState({lastEventTitle: this.props.movie.film_translated_title})
        }
     }

     handleLoad() {
        window.prerenderReady = true;
     }

    toggle(which) {
        if(which === 'carousel') {
            this.setState({
                openModal: !this.state.openModal,
                openVideoPlayerModal: false,
                openShareModal: false,
            });
        } else if(which === 'share') {
            this.setState({
                openModal: false,
                openVideoPlayerModal: false,
                openShareModal: !this.state.openShareModal,
            });
        } else if(which === 'video') {
            this.setState({
                openModal: false,
                openVideoPlayerModal: !this.state.openVideoPlayerModal,
                openShareModal: false,
            });
        }
    }

    openCarouselModal = () => {
        this.setState({
            openModal: true,
            openVideoPlayerModal: false,
            openShareModal: false
        });
    };

    openVideoPlayerModal = () => {
        this.setState({
            openModal: false,
            openVideoPlayerModal: true,
            openShareModal: false
        });
    };

    openShareModal = () => {
        this.setState({
            openModal: false,
            openVideoPlayerModal: false,
            openShareModal: true,
        });
    };

    getCriticsComments = () => {
        if(this.props.movie.film_critic_reviews){
            let criticsReviews = [];
            this.props.movie.film_critic_reviews.map((comment) => {
                criticsReviews.push(
                    {
                        comment_author_image: comment.review_author_image,
                        comment_created: comment.review_created,
                        comment_author_first_name: comment.review_author_first_name,
                        comment_author_last_name: comment.review_author_last_name,
                        comment_text: comment.review_text
                    }
                )
            });
            return criticsReviews;
        }  
    };

    getUsersComments = () => {
        if(this.props.movie.film_user_reviews){
            let usersReviews = [];
            this.props.movie.film_user_reviews.map((comment) => {
                usersReviews.push(
                    {
                        comment_author_image: comment.review_author_image,
                        comment_created: comment.review_created,
                        comment_author_first_name: comment.review_author_first_name,
                        comment_author_last_name: comment.review_author_last_name,
                        comment_text: comment.review_text
                    }
                )
            });
            return usersReviews;
        }  
    }

    isUserAuthenticated = () => {
        return localStorage.getItem('login_type') === 'authenticated' ? true : false;
    };

    getDistributions = () => {
        if (this.props.movie.film_cast){
            const cast = arrayClone(this.props.movie.film_cast);

            return cast.reverse().map((distribution, i) => {
                if(i <= 6) {
                    return <div className="col col-sm-2 item-distr" key={i}>
                        <img src={API_URL + Parser(distribution.celebrity_image)} alt={distribution.celebrity_name}/>
                        <p className="actor-name">{distribution.celebrity_name}</p>
                    </div>
                }
            })
        }
    }

    addMovieToFavorite = () => {
        if(this.isUserAuthenticated()) {
            this.props.addMovieToFavorite(this.props.movie.film_uuid);
        } else {
            this.props.history.push(LOGIN_ROUTE)
        }
    }
    
    removeMovieFromFavorite = () => {
        if(this.isUserAuthenticated()) {
            this.props.removeMovieFromFavorite(this.props.movie.favorite[0].uuid);
        } else {
            this.props.history.push(LOGIN_ROUTE)
        }
    }


    favoriteSection = () => {
        if(this.props.movie.favorite){
            return (this.props.movie.favorite.length !== 0  ? 
                 <Fragment>
                    <span className="add-mov-fav-active" onClick={this.removeMovieFromFavorite} />
                    <span className="share-mov" onClick={this.openShareModal} />
                 </Fragment>  :
                 <Fragment>
                     <span className="add-mov-fav" onClick={this.addMovieToFavorite} />
                     <span className="share-mov" onClick={this.openShareModal}/>
                </Fragment>
            )
        }
    };

    getDescription = () => {
        if(this.props.movie.film_description !== undefined) {
            if(this.props.movie.film_description.length > 0) {
                return Parser(this.props.movie.film_description);
            } else {
                return <p style={{ marginBottom: `0px` }}>Nu exista descriere pentru filmul <b>{this.props.movie.film_title}</b></p>
            }
        }
    };

    addComment = (data) => {
        if (this.isUserAuthenticated()) {
            const comment = {
                filmId: this.props.movieId,
                comment: data
            }
            this.props.sendMovieReview(comment)
        } else {
            this.props.history.push(LOGIN_ROUTE);
        }
    };

    getVideoImagePreview = () => {
        if (this.props.movie.film_poster) {
            return this.props.movie.film_trailer_preview !== "" ? API_URL + Parser(this.props.movie.film_trailer_preview) : API_URL + Parser(this.props.movie.film_poster_orig);
        } 
    }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>{ (this.props.movie.film_translated_title ? Parser (this.props.movie.film_translated_title) : Parser(String(this.props.movie.film_title))) + ' (' + this.props.movie.film_release_year+')' }</title>
                    <meta name="description" content={this.props.movie.film_description ? getFormattedTextForMeta(this.props.movie.film_description, 1) : `Nu exista descriere pentru filmul ${Parser(String(this.props.movie.film_title))}`}/>
                    <link rel='canonical' href={window.location.href} />
                    
                    <meta property="og:url"                content={window.location.href} />
                    <meta property="og:type"               content="article" />
                    <meta property="og:title"              content={this.props.movie.film_title ? Parser(this.props.movie.film_title) : ""} />
                    <meta property="og:description"        content={this.props.movie.film_description && getFormattedTextForMeta(this.props.movie.film_description, 1)} />
                    <meta property="og:image"              content={API_URL + this.props.movie.film_poster} />
                    <meta property="og:image:width"        content="200" />
                    <meta property="og:image:height"       content="500" />

                    <meta name="twitter:card" content="summary" />
                    <meta name="twitter:site" content={window.location.href} />
                    <meta name="twitter:title" content={this.props.movie.film_title ? Parser(this.props.movie.film_title) : ""} />
                    <meta name="twitter:description" content={this.props.movie.film_description && getFormattedTextForMeta(this.props.movie.film_description, 1)} />
                    <meta name="twitter:image" content={API_URL + this.props.movie.film_poster} />
                </Helmet>

                <Spinner />
                <ModalCarousel toggle={() => this.toggle('carousel')} openModal={this.state.openModal} images={this.props.movie.film_image_gallery} className={"modalCarousel"}/>
                {/* <ModalVideoPlayer size="lg" toggle={() => this.toggle('video')} openModal={this.state.openVideoPlayerModal} url={this.props.movie.film_trailer} className={"modalVideoPlayer"}/> */}
                <ModalShare toggle={() => this.toggle('share')} openModal={this.state.openShareModal} className={"modalShare"} poster={API_URL + this.props.movie.film_poster}/>
                <div className="movie-details-page">
                    <div className="container-fluid">
                        <div className="row">
                        {   window.innerWidth > 1000 ? 
                            <Ads
                                id="div-gpt-ad-1662463178982-0"
                                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
                            /> : 
                            <Ads
                                id="div-gpt-ad-1662463706379-0"
                                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
                            />
                        }
                            <div className="movie-details">
                                <h1 className="movie-title block">{this.props.movie.film_translated_title ? Parser (this.props.movie.film_translated_title) : Parser(String(this.props.movie.film_title))}<span> ({this.props.movie.film_release_year})</span></h1>
                                <span className="movie-title-translated block">{this.props.movie.film_title ? Parser(String(this.props.movie.film_title)) : ""}</span>
                                { this.favoriteSection() }
                            </div>
                        </div>
                    </div>
                    <div className="wrapper-media">
                        <div className="row slider-carousel">
                            <div className="col-lg-2 slider-item poster-card" onClick={this.openCarouselModal}>
                                <img src={this.props.movie.film_poster ? API_URL + Parser(this.props.movie.film_poster): ""} alt="Film"/>
                            </div>
                            {this.props.movie.film_trailer ?
                                <Fragment>
                                    <div className={this.props.movie.film_image_gallery !== undefined && this.props.movie.film_image_gallery.length > 0 ? "col-lg-6 video-preview" : "col-lg-10 video-preview"} onClick={this.openVideoPlayerModal}>
                                        {/* <div className="play-button" />
                                    <img src={this.getVideoImagePreview()} alt="Previzualizare clip video film"/> */}
                                        <ReactPlayer controls={true} width='100%' height="100%" url={this.props.movie.film_trailer} />
                                    </div>
                                    <div className="col-lg-4 carousel-items" onClick={this.openCarouselModal}>
                                        <CarouselTiles cards={this.props.movie.film_image_gallery} />
                                    </div>
                                </Fragment> :
                                <div className="col-lg-10 carousel-items" onClick={this.openCarouselModal}>
                                    <CarouselTiles cards={this.props.movie.film_image_gallery} />
                                </div>
                            }
                        </div>
                    </div>

                    <div className="mov-details">
                        <div className="container-fluid clearfix">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="col-lg-12 clearfix nopadding">
                                        <span className="white-text rating-grade float-left">{this.props.movie.film_rating_visitors}</span>
                                        <CinemapRating rating={this.props.movie.film_rating_visitors} movieId={this.props.movie.film_id} />
                                    </div>
                                    <div className="col-lg-12 clearfix nopadding">
                                        <span className="imdb-icon float-left"/>
                                        <span className="grade white-text float-left">{this.props.movie.film_rating_imdb}</span>
                                        <span className="star-icon float-left"/>

                                        <span className="rotten-icon"/>
                                        <span className="grade white-text float-left">{this.props.movie.film_rating_rotten_tomatoes}</span>
                                        <span className="white-text rating-critics float-left">Rating critici</span>
                                        <span className="grade-critics white-text float-left">{this.props.movie.film_rating_critics}</span>
                                        <span className="star-icon float-left"/>
                                    </div>

                                    <div className="col-lg-12 clearfix nopadding text-details">
                                        <span className="status-mov white-text"><span className="grey-text">STATUS: </span>{this.props.movie.film_status}</span>
                                        <span className="grey-text db">{this.props.movie.film_age_restrictions} | {this.props.movie.film_duration} | {this.props.movie.film_genre} {this.props.movie.film_projection_formats ? "| " + this.props.movie.film_projection_formats : ""}</span>
                                        <span className="light-grey-text db">Data aparitiei: {" "}
                                            <Moment format="DD MMMM YYYY" locale="ro" unix>
                                                { this.props.movie.film_release_date }
                                            </Moment></span>
                                        <span className="grey-text db">Director: {this.props.movie.film_director}</span>
                                        <span className="light-grey-text db">Writers: {this.props.movie.film_scenarist}</span>
                                        {/* <span className="grey-text db">Stars: Paul Rudd, Evangeline Lilly, Michael Pena, Paul Rudd</span> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 distribution-images">
                                    <p className="white-text text-right">Din distributie:</p>
                                    <div className="distribution-wrapper">
                                        <div className="row">
                                            {this.getDistributions()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="movie-content">
                        <div className="container-fluid clearfix">
                            <div className="row">
                                <div className="col-lg-9 mov-text-content">
                                    <div className="actual-content">
                                        { this.getDescription() }
                                    </div>
                                    <Comments
                                        comments={this.getCriticsComments()}
                                        className={'critics'}
                                        showInput={false}
                                        headline={"Ce spun criticii"}
                                    />
                                    <br/>
                                    <RatingsComments
                                        comments={this.getUsersComments()}
                                        rating={this.props.movie.rating}
                                        movieId={this.props.match.params.id}
                                        className={'users'}
                                        showInput={true}
                                        headline={"Ce spun utilizatorii"}
                                    />
                                </div>
                                <div className="col-lg-3 right-sidebar">
                                    <p className="grey-text">Program cinema</p>

                                    <div className="col-lg-12">
                                        <div className="row">
                                            <WeekDaysCards film_id={this.props.movie.film_id} />
                                        </div>
                                    </div>
                                    <SelectHours isUserAuthenticated={this.isUserAuthenticated()} />
                                </div>              
                            </div>
                        </div>
                    </div>

                    <div className="section-headline">
                        FILME RECOMANDATE PENTRU TINE
                    </div>

                    <SerialsRecommendedForYou />

                    {/*<div className="section-headline">
                        ARTICOLE RECOMANDATE
                    </div>

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <RecommendedForYou />
                            </div>
                        </div>
                    </div>*/}

                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    movie: state.movies.movieDetails,
    lastNews: state.news.lastNews
});
export default withRouter(connect(mapStateToProps, {getMovieDetails, addMovieToFavorite, removeMovieFromFavorite, requestLastNews, sendMovieReview})(MovieDetails));





// WEBPACK FOOTER //
// ./src/FO/components/moviedetails/moviedetails.component.js